import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'amazonFullPath'
})
export class AmazonFullPathPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
